import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { Router } from '@angular/router';
import { CampaignService, CampaignConfig } from '../../services/campaign.service';
import { FacilityService, Facility } from '../../services/facility.service';
import { QRCodeModule } from 'angularx-qrcode';
import { SafeResourceUrlPipe } from '../../pipes/safe-resource-url.pipe';

@Component({
  selector: 'app-iam-campaign-landing',
  standalone: true,
  imports: [CommonModule, FormsModule, QRCodeModule, SafeResourceUrlPipe],
  templateUrl: './iam-campaign-landing.component.html',
  styleUrl: './iam-campaign-landing.component.css'
})
export class IamCampaignLandingComponent implements OnInit {
  activePersonaKey = 'navigator';

  get activePersona() {
    if (!this.campaignData || !this.campaignData.personas) return null;
    return this.campaignData.personas.find(p => p.key === this.activePersonaKey);
  }

  campaignData: CampaignConfig | null = null;
  districts: string[] = [];
  services: string[] = [];
  facilities: Facility[] = [];
  qrCodeData: string | null = null;

  activeVideo: any = null;
  heroVideoActive: boolean = false;

  constructor(
    private analytics: Analytics, 
    private campaignService: CampaignService, 
    private facilityService: FacilityService,
    private router: Router
  ) {}

  ngOnInit() {
    this.campaignService.getCampaignBySlug('i-am').subscribe(data => {
      this.campaignData = data || null;
      if (this.campaignData?.videos?.length) {
        this.activeVideo = this.campaignData.videos[0];
      }
    });

    this.facilityService.getDistricts().subscribe(d => this.districts = d);
    this.facilityService.getServices().subscribe(s => this.services = s);
    // Initialize default selections
    this.selectedDistrict = 'Lusaka';
    this.selectedService = 'PrEP Services';
  }

  selectVideo(video: any) {
    this.activeVideo = video;
    logEvent(this.analytics, 'iam_video_play', {
      video_id: video.id,
      video_title: video.title
    });
  }

  toggleHeroVideo() {
    this.heroVideoActive = !this.heroVideoActive;
    if (this.heroVideoActive) {
      logEvent(this.analytics, 'iam_hero_video_play', {
        campaign_slug: 'i-am'
      });
    }
  }

  viewDetails(resource: any) {
    this.router.navigate(['/campaign/details', resource.nid], { state: { item: resource } });
  }

  setPersona(key: string) {
    this.activePersonaKey = key;
    logEvent(this.analytics, 'iam_persona_switch', { persona: key });
  }

  toggleFaq(index: number) {
    if (this.campaignData && this.campaignData.faqs) {
      this.campaignData.faqs[index].open = !this.campaignData.faqs[index].open;
    }
  }

  selectedDistrict = '';
  selectedService = '';
  showResults = false;

  findServices() {
    this.showResults = true;
    
    // Fetch dynamic facilities based on selection
    this.facilityService.findFacilities(this.selectedDistrict, this.selectedService).subscribe(results => {
      this.facilities = results;
    });

    // Generate QR Code data (Mock payload: userId + district + service + timestamp)
    this.qrCodeData = `ref-i-am-${this.selectedDistrict}-${this.selectedService}-${Date.now()}`;
    
    logEvent(this.analytics, 'iam_service_search', {
      district: this.selectedDistrict,
      service: this.selectedService
    });
    
    logEvent(this.analytics, 'qr_code_generated', {
      payload: this.qrCodeData
    });
  }

  downloadQR() {
    logEvent(this.analytics, 'qr_code_downloaded', {
      payload: this.qrCodeData
    });
    alert('QR Code downloaded successfully for offline use!');
  }

  scrollTo(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
